<template>
  <div class="export-data">
    <div class="common-title-page export-pod-data">
      <div class="page-title">POD DATA STREAM</div>
      <div class="page-content max-wp-100 pt-0">
        <div class="mt-20 mb-10">
          <span class="header-grey-font bold-font font-16 mr-20">{{
            $t('text.raw_data')
          }}</span>
          <el-checkbox v-model="autoRefresh">{{
            $t('text.auto_refresh')
          }}</el-checkbox>
          <span class="right-float">
            <img src="../../assets/filter.svg" />
            <el-input
              v-model="filter"
              size="mini"
              class="search-input filter-input"
              placeholder="mac address / node mac"
            ></el-input>
          </span>
        </div>
        <ul class="raw-data-wrapper">
          <li v-for="(item, index) in rawData" :key="index">{{ item }}</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import swal from 'sweetalert'
import ApiService from '@/services/ApiService.js'
export default {
  data() {
    return {
      autoRefresh: true,
      loading: false,
      rawData: [],
      timer: '',
      filter: '',
      filterTimer: ''
    }
  },
  watch: {
    filter() {
      if (this.filterTimer) {
        clearTimeout(this.filterTimer)
      }
      this.filterTimer = setTimeout(this.getData, 500)
    },
    autoRefresh() {
      if (!this.autoRefresh) {
        clearInterval(this.timer)
      } else {
        this.timer = setInterval(this.getData, 2000)
      }
    }
  },
  mounted: function() {
    this.getData()
    this.timer = setInterval(this.getData, 2000)
  },
  methods: {
    getData() {
      this.loading = true
      ApiService.LatestRecords()
        .then(response => {
          this.loading = false
          this.rawData = []
          let vm = this
          response.data.forEach(item => {
            if (item && item.length) {
              item.forEach(subItem => {
                vm.rawData.push(subItem)
              })
            }
          })
          if (this.filter) {
            this.rawData = this.rawData.filter(
              item =>
                (item.mac &&
                  item.mac.toLowerCase().indexOf(vm.filter.toLowerCase()) >
                    -1) ||
                (item.podId &&
                  item.podId.toLowerCase().indexOf(vm.filter.toLowerCase()) >
                    -1) ||
                (item.nodeMac &&
                  item.nodeMac.toLowerCase().indexOf(vm.filter.toLowerCase()) >
                    -1) ||
                (item.NodeMac &&
                  item.NodeMac.toLowerCase().indexOf(vm.filter.toLowerCase()) >
                    -1)
            )
          }
        })
        .catch(() => {
          this.loading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  }
}
</script>
